var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArizonaDiamondbacksLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 157.91,
    width: 183.88,
    viewBox: "0 0 183.87696 157.91211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.14 -451.39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.86298 -1.1506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m148.17 1.1367-48.504 0.0352-98.516 155.87h77.734l-11.141-23.424 24.008-40.305c0.62697 2.4858 1.8834 7.4086 2.0723 8.1602-1.2278 2.1301-19.795 34.254-19.795 34.254l28.65-23.68c0.45616 0.55865 20.293 24.611 20.293 24.611s-9.3281-31.144-9.9551-33.262c0.47425-0.75961 3.5871-5.7335 5.5625-8.8945l8.4883 39.207-16.965 23.336h72.924l-34.86-155.9zm-40.26 65.061h4.5273l5.5664 25.688h-25.4l15.307-25.688z",
    transform: "translate(-138.29 452.26)",
    fill: "#e3d4ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.84 4.0938 2.082 3.1855h36.119l31.992 143.61h-51.973l11.609-15.701-16.666-74.553-13.779-0.0039-44.465 73.135 8.2988 17.064h-51.492l-5.0566 3.1328h62.102l-9.8281-20.262 42.17-70.322h9.1836l15.922 71.029-14.305 19.576 62.307-0.0156-33.32-149.85-40.89-0.0262zm-3.34 0.3613-94.74 149.45 46.437-29.23 5.381-3.41-9.576-22.774 30.504-19.119-10.485-18.795 29.504-14.242-9.517-16.768 22.712-10.095-8.3-12.196-1.92-2.8259z",
    transform: "translate(-138.29 452.26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.92 7.2812 8.9004 13.666-22.441 10.096 9.666 16.736-29.488 14.109 9.8672 18.291-30.512 19.227 9.3984 23.061-45.748 28.365h51.492l-8.2969-17.064 44.465-73.135 13.779 0.0039 16.668 74.553-11.611 15.701h51.973l-31.992-143.61h-36.119zm-11.457 87.768s1.4342 5.6424 1.7598 6.9004c-0.87214 1.5051-11.629 20.111-11.629 20.111s15.334-12.676 17.508-14.469c1.5031 1.8186 12.336 14.955 12.336 14.955s-5.3587-17.909-5.8711-19.615c0.79376-1.272 4.9316-7.8828 4.9316-7.8828h-19.035z",
    transform: "translate(-138.29 452.26)",
    fill: "#a71930"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArizonaDiamondbacksLogo);
export default __webpack_public_path__ + "static/media/arizona-diamondbacks-logo.cfafc644b4675059d450a18bc3e7e792.svg";
export { ForwardRef as ReactComponent };